import axios from 'axios'
import * as types from '../mutation-types'
import {
  createTheParametersOfTheUrl,
} from '../../plugins/helper'

const doToArrayObject = datos => {
  const term = []
  Object.keys(datos).forEach(key => {
    term.push({
      value: datos[key].id,
      text: datos[key].name || datos[key].nombre,
      reference: datos[key].reference || null,
      contractor_id: datos[key].contractor_id || null,
    })
  })

  return term
}

// state
export const state = {
  loading: true,
  contracts: [],
  error: null,
  loadingContractsProject: true,
  contractsProject: null,
  errorContractsProject: null,
  contractsAsList: [],
  loadingContractsAsList: true,
  errorContractsAsList: null,
  loadingGetHousesContracts: false,
  getHousesContracts: [],
  errorGetHousesContracts: null,
  loadingFindContract: false,
  contract: null,
  errorFindContract: null,
}

// mutations
export const mutations = {
  [types.GET_CONTRACTS_START] (state) {
    state.loading = true
    state.contracts = []
    state.error = null
  },

  [types.GET_CONTRACTS_SUCCESS] (state, { data }) {
    state.loading = false
    state.contracts = data
    state.error = null
  },

  [types.GET_CONTRACTS_ERROR] (state, { error }) {
    state.loading = false
    state.contracts = []
    state.error = error
  },

  [types.GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_START] (state) {
    state.loadingContractsProject = true
    state.contractsProject = null
    state.errorContractsProject = null
  },

  [types.GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_SUCCESS] (state, { data }) {
    state.loadingContractsProject = false
    state.contractsProject = data
    state.errorContractsProject = null
  },

  [types.GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_ERROR] (state, { error }) {
    state.loadingContractsProject = false
    state.contractsProject = null
    state.errorContractsProject = error
  },

  [types.GET_CONTRACT_FOR_PROJECT_ID_START] (state) {
    state.loadingContractsAsList = true
    state.contractsAsList = []
    state.errorContractsAsList = null
  },

  [types.GET_CONTRACT_FOR_PROJECT_ID_SUCCESS] (state, { data }) {
    state.loadingContractsAsList = false
    state.contractsAsList = doToArrayObject(data)
    state.errorContractsAsList = null
  },

  [types.GET_CONTRACT_FOR_PROJECT_ID_ERROR] (state, { error }) {
    state.loadingContractsAsList = false
    state.contractsAsList = []
    state.errorContractsAsList = error
  },

  [types.GET_HOUSES_CONTRACTS_START] (state) {
    state.loadingGetHousesContracts = true
    state.getHousesContracts= []
    state.errorGetHousesContracts = null
  },

  [types.GET_HOUSES_CONTRACTS_SUCCESS] (state, { data }) {
    state.loadingGetHousesContracts = false
    state.getHousesContracts = doToArrayObject(data. data)
    state.errorGetHousesContracts = null
  },

  [types.GET_HOUSES_CONTRACTS_ERROR] (state, { error }) {
    state.loadingGetHousesContracts = false
    state.getHousesContracts = []
    state.errorGetHousesContracts = error
  },

  [types.GET_CONTRACT_START] (state) {
    state.loadingFindContract = true
    state.contract = null
    state.errorFindContract = null
  },

  [types.GET_CONTRACT_SUCCESS] (state, { data }) {
    state.loadingFindContract = false
    state.contract = data
    state.errorFindContract = null
  },

  [types.GET_CONTRACT_ERROR] (state, { error }) {
    state.loadingFindContract = false
    state.contract = null
    state.errorFindContract = error
  },
}

export const actions = {
  async getContract ({ commit }, contractId) {
    try {
      commit(types.GET_CONTRACT_START)

      const { data } = await axios.get(`/api/contracts/find/${contractId}`)

      commit(types.GET_CONTRACT_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_CONTRACT_ERROR, { error: null })
    }
  },

  async getContracts ({ commit }, payload) {
    try {
      commit(types.GET_CONTRACTS_START)

      const { data } = await axios.get('/api/contracts/contract_activities?name=' + payload)

      commit(types.GET_CONTRACTS_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_CONTRACTS_ERROR, { error: null })
    }
  },

  async getContractForHousingAndProjectID ({ commit }, { projectId, houseId }) {
    try {
      commit(types.GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_START)

      const { data } = await axios.get(`/api/houses/get_contract/${projectId}/${houseId}`)

      commit(types.GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_CONTRACT_FOR_HOUSING_AND_PROJECT_ID_ERROR, { error: null })
    }
  },

  async getContractForProjectID ({ commit }, { projectId }) {
    try {
      commit(types.GET_CONTRACT_FOR_PROJECT_ID_START)

      const { data } = await axios.get(`/api/contracts/list/${projectId}`)

      commit(types.GET_CONTRACT_FOR_PROJECT_ID_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_CONTRACT_FOR_PROJECT_ID_ERROR, { error: null })
    }
  },

  async getHouseContracts ({ commit }, { projectId, typeContract, params }) {
    try {
      commit(types.GET_HOUSES_CONTRACTS_START)

      const href = createTheParametersOfTheUrl(params)
      const { data } = await axios.get(`/api/projects/house_contracts/${projectId}/${typeContract}${href}`)

      commit(types.GET_HOUSES_CONTRACTS_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_HOUSES_CONTRACTS_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingContract: state => state.loading,
  contracts: state => state.contracts,
  errorContract: state => state.error,
  loadingContractsProject: state => state.loadingContractsProject,
  contractsProject: state => state.contractsProject,
  errorContractsProject: state => state.errorContractsProject,
  contractsAsList: state => state.contractsAsList,
  loadingContractsAsList: state => state.loadingContractsAsList,
  errorContractsAsList: state => state.errorContractsAsList,
  loadingGetHousesContracts: state => state.loadingGetHousesContracts,
  getHousesContracts: state => state.getHousesContracts,
  errorGetHousesContracts: state => state.errorGetHousesContracts,
  loadingFindContract: state => state.loadingFindContract,
  contract: state => state.contract,
  errorFindContract: state => state.errorFindContract,
}
